import { connect } from "react-redux";
import { ApplicationState } from "store";
import { getCalendar } from "page/calendar/store";
import CalendarDatePicker from "./calendar-date-picker";
import { getIsAuthenticated } from "user/store";
import { getResource } from "resource/store";
import { actionCreators } from "page/calendar/store";
import { actionCreators as burdeContentActionCreators } from "burde-api-content/store";

const mapStateToProps = (state: ApplicationState) => ({
    DatePicker_SelectMonth: getResource(state, {
        key: "DatePicker_SelectMonth",
    }),
    calendar: getCalendar(state),
    isAuthenticated: getIsAuthenticated(state),
});

const mapDispatchToProps = {
    ...actionCreators,
    ...burdeContentActionCreators,
};

export default connect(mapStateToProps, mapDispatchToProps)(CalendarDatePicker);
